/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import keyBy from 'lodash/fp/keyBy.js';
import { COLLAPSE_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';

const { COLLAPSE_METHOD_FEMA, COLLAPSE_METHOD_MCE, COLLAPSE_METHOD_MEDIAN } =
  COLLAPSE_METHOD_VALUES;

const methods = [
  { id: COLLAPSE_METHOD_FEMA, name: 'FEMA P-154', showInJapan: false },
  { id: COLLAPSE_METHOD_MCE, name: 'Probability of Collapse at MCE', showInJapan: false },
  { id: COLLAPSE_METHOD_MEDIAN, name: 'Median', showInJapan: true },
];

export const methodById = keyBy('id', methods);

export default methods;
